export default {
  refresh: 'Obnoviť PDF',
  refreshHint: 'Vytvorí správu znova s aktuálnou šablónou a nahradí uloženú správu pre všetkých.',
  longRunning: {
    summary: 'Vytváranie správy auditu',
    detail: 'Vytvorenie správy môže chvíľu trvať. Nechajte toto okno otvorené. Táto správa sa zatvorí, keď sa začne sťahovanie.',
  },
};
